function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o);
}
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
    var o, i = p[t], d = G.p, l = i[2];
    r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
} if (o || r > 1)
    return a; throw y = !0, n; } return function (o, p, l) { if (f > 1)
    throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
    try {
        if (f = 2, i) {
            if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u)))
                    throw TypeError("iterator result is not an object");
                if (!t.done)
                    return t;
                u = t.value, c < 2 && (c = 0);
            }
            else
                1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
            i = e;
        }
        else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a)
            break;
    }
    catch (t) {
        i = e, c = 1, u = t;
    }
    finally {
        f = 1;
    }
} return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() { } function GeneratorFunction() { } function GeneratorFunctionPrototype() { } t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try {
    i({}, "", {});
}
catch (e) {
    i = 0;
} _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try {
    var i = n[a](c), u = i.value;
}
catch (n) {
    return void e(n);
} i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import React, { useEffect, useState, Suspense } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { Box, Skeleton, Stack } from '@mui/material';
import authenticatedRoute from '../views/AuthenticatedRoute';
import { useApplicationsList } from '../components/ApplicationContext';
import RemoteAppWrapper from '../components/RemoteAppWrapper';
var createAndLoadScript = function createAndLoadScript(url, scope, resolve, reject) {
    var script = document.createElement('script');
    script.src = url;
    script.type = 'text/javascript';
    script.async = true;
    script.onload = function () {
        setTimeout(function () {
            return handleScriptTimeout(resolve, scope);
        }, 100);
    };
    script.onerror = function (error) {
        console.error("\u274C Failed to load remote entry:", error);
        reject(new Error("Failed to load ".concat(url)));
    };
    document.head.appendChild(script);
};
var loadRemoteEntry = function loadRemoteEntry(url, scope) {
    var forceReload = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    return new Promise(function (resolve, reject) {
        try {
            // Check if container already exists and not forcing reload
            if (globalThis[scope]) {
                if (!forceReload) {
                    // Use existing container
                    return resolve();
                }
                // If forceReload, remove existing script tags to force fresh load
                var existingScripts = Array.from(document.querySelectorAll('script'));
                for (var _i = 0, _existingScripts = existingScripts; _i < _existingScripts.length; _i++) {
                    var script = _existingScripts[_i];
                    if (script.src === url) {
                        script.remove();
                    }
                }
                // Note: We cannot delete the container from globalThis (non-configurable)
                // The script will reload and reinitialize the container
            }
            // Module Federation remotes MUST be loaded as classic scripts
            // They expose a UMD/global variable even if they contain ES module syntax
            createAndLoadScript(url, scope, resolve, reject);
        }
        catch (error) {
            reject(error instanceof Error ? error : new Error(String(error)));
        }
    });
};
var handleScriptTimeout = function handleScriptTimeout(resolve, scope) {
    if (globalThis[scope]) {
        resolve();
    }
    else {
        var availableContainers = Object.keys(globalThis).filter(function (k) {
            return k.toLowerCase().includes('app') || k.toLowerCase().includes('remote') || k.includes('Remote') || k.includes('App');
        });
        console.error("Container ".concat(scope, " not found. Available: ").concat(availableContainers.join(', ')));
        resolve(); // Continue anyway - let next step handle error
    }
};
var loadRemoteComponent = /*#__PURE__*/ function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee(scope, module, entryUrl) {
        var forceReload, container, availableContainers, factory, Module, _args = arguments;
        return _regenerator().w(function (_context) {
            while (1)
                switch (_context.n) {
                    case 0:
                        forceReload = _args.length > 3 && _args[3] !== undefined ? _args[3] : false;
                        _context.n = 1;
                        return loadRemoteEntry(entryUrl, scope, forceReload);
                    case 1:
                        _context.n = 2;
                        return __webpack_init_sharing__('default');
                    case 2:
                        container = globalThis[scope];
                        if (container) {
                            _context.n = 3;
                            break;
                        }
                        availableContainers = Object.keys(globalThis).filter(function (k) {
                            return k.includes('App') || k.includes('app') || k.includes('Remote') || k.includes('remote');
                        });
                        console.error("Remote container ".concat(scope, " not found. Available: ").concat(availableContainers.join(', ')));
                        throw new Error("Remote container ".concat(scope, " not found. Available: ").concat(availableContainers.join(', ')));
                    case 3:
                        _context.n = 4;
                        return container.init(__webpack_share_scopes__["default"]);
                    case 4:
                        _context.n = 5;
                        return container.get(module);
                    case 5:
                        factory = _context.v;
                        Module = factory();
                        return _context.a(2, Module);
                }
        }, _callee);
    }));
    return function loadRemoteComponent(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Creates a React wrapper for non-React frameworks (Angular, Vue, etc.)
 * that use a mount/unmount pattern
 */
var createFrameworkWrapper = function createFrameworkWrapper(mountFn, unmountFn) {
    return function FrameworkWrapper(props) {
        var containerRef = React.useRef(null);
        var instanceRef = React.useRef(null);
        var mountId = React.useId().replaceAll(':', '');
        React.useEffect(function () {
            if (!containerRef.current)
                return;
            // Create mount container
            var mountContainer = document.createElement('div');
            mountContainer.id = "remote-mount-".concat(mountId);
            containerRef.current.appendChild(mountContainer);
            // Mount the framework app
            try {
                instanceRef.current = mountFn(mountContainer.id, props);
            }
            catch (error) {
                console.error('Error mounting remote app:', error);
            }
            // Cleanup on unmount
            return function () {
                if (instanceRef.current && unmountFn) {
                    try {
                        unmountFn(instanceRef.current);
                    }
                    catch (error) {
                        console.error('Error unmounting remote app:', error);
                    }
                }
                if (mountContainer.parentNode) {
                    mountContainer.remove();
                }
            };
        }, []);
        return /*#__PURE__*/ React.createElement('div', {
            ref: containerRef,
            style: {
                width: '100%',
                height: '100%'
            }
        });
    };
};
// Helper function to load remote component (extracted to reduce nesting)
var loadComponentAsync = /*#__PURE__*/ function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee2(scope, product, entryUrl, setRemoteComponent) {
        var forceReload, mod, Component, _Component$prototype, isReactComponent, _Component$unmount, WrappedComponent, instance, _instance$unmount, _WrappedComponent, _args2 = arguments, _t, _t2;
        return _regenerator().w(function (_context2) {
            while (1)
                switch (_context2.p = _context2.n) {
                    case 0:
                        forceReload = _args2.length > 4 && _args2[4] !== undefined ? _args2[4] : false;
                        _context2.p = 1;
                        _context2.n = 2;
                        return loadRemoteComponent(scope, './app', entryUrl, forceReload);
                    case 2:
                        mod = _context2.v;
                        // Handle different export patterns
                        Component = mod["default"] || mod; // Case 1: Already a React component
                        if (!(typeof Component === 'function')) {
                            _context2.n = 3;
                            break;
                        }
                        // Check if it looks like a React component
                        isReactComponent = ((_Component$prototype = Component.prototype) === null || _Component$prototype === void 0 ? void 0 : _Component$prototype.isReactComponent) ||
                            // Class component
                            Component.toString().includes('React.createElement') ||
                            // Likely React function
                            Component.$$typeof; // React element type
                        if (!(isReactComponent || Component.length <= 1)) {
                            _context2.n = 3;
                            break;
                        }
                        // Accept it as a React component
                        setRemoteComponent(/*#__PURE__*/ React.lazy(function () {
                            return Promise.resolve({
                                "default": Component
                            });
                        }));
                        return _context2.a(2);
                    case 3:
                        if (!(Component && _typeof(Component) === 'object')) {
                            _context2.n = 4;
                            break;
                        }
                        if (!(typeof Component.mount === 'function')) {
                            _context2.n = 4;
                            break;
                        }
                        WrappedComponent = createFrameworkWrapper(Component.mount.bind(Component), (_Component$unmount = Component.unmount) === null || _Component$unmount === void 0 ? void 0 : _Component$unmount.bind(Component));
                        setRemoteComponent(/*#__PURE__*/ React.lazy(function () {
                            return Promise.resolve({
                                "default": WrappedComponent
                            });
                        }));
                        return _context2.a(2);
                    case 4:
                        if (!(typeof Component === 'function')) {
                            _context2.n = 8;
                            break;
                        }
                        _context2.p = 5;
                        instance = Component();
                        if (!(instance && typeof instance.mount === 'function')) {
                            _context2.n = 6;
                            break;
                        }
                        _WrappedComponent = createFrameworkWrapper(instance.mount.bind(instance), (_instance$unmount = instance.unmount) === null || _instance$unmount === void 0 ? void 0 : _instance$unmount.bind(instance));
                        setRemoteComponent(/*#__PURE__*/ React.lazy(function () {
                            return Promise.resolve({
                                "default": _WrappedComponent
                            });
                        }));
                        return _context2.a(2);
                    case 6:
                        _context2.n = 8;
                        break;
                    case 7:
                        _context2.p = 7;
                        _t = _context2.v;
                    case 8:
                        throw new Error("Invalid export format in ".concat(scope, ". Expected:\n") + "- React component (function/class)\n" + "- Object with mount() method\n" + "- Function returning {mount, unmount}\n" + "Got: ".concat(_typeof(Component)));
                    case 9:
                        _context2.p = 9;
                        _t2 = _context2.v;
                        console.error("Error loading ".concat(scope, ":"), _t2);
                    case 10:
                        return _context2.a(2);
                }
        }, _callee2, null, [[5, 7], [1, 9]]);
    }));
    return function loadComponentAsync(_x4, _x5, _x6, _x7) {
        return _ref2.apply(this, arguments);
    };
}();
// Skeleton loader component (extracted from parent component)
var SkeletonLoader = function SkeletonLoader() {
    return /*#__PURE__*/ React.createElement(Box, {
        sx: {
            p: 3,
            width: '100%'
        },
        "data-testid": "skeleton-loader"
    }, /*#__PURE__*/ React.createElement(Stack, {
        spacing: 2
    }, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            mb: 3
        }
    }, /*#__PURE__*/ React.createElement(Skeleton, {
        variant: "circular",
        width: 40,
        height: 40
    }), /*#__PURE__*/ React.createElement(Box, {
        sx: {
            flex: 1
        }
    }, /*#__PURE__*/ React.createElement(Skeleton, {
        variant: "text",
        width: "30%",
        height: 32
    }), /*#__PURE__*/ React.createElement(Skeleton, {
        variant: "text",
        width: "15%",
        height: 20
    }))), /*#__PURE__*/ React.createElement(Box, {
        sx: {
            mb: 4
        }
    }, /*#__PURE__*/ React.createElement(Skeleton, {
        variant: "rectangular",
        width: "100%",
        height: 200,
        sx: {
            borderRadius: 2,
            mb: 2
        }
    }), /*#__PURE__*/ React.createElement(Stack, {
        direction: "row",
        spacing: 2
    }, /*#__PURE__*/ React.createElement(Skeleton, {
        variant: "rectangular",
        width: "48%",
        height: 120,
        sx: {
            borderRadius: 1
        }
    }), /*#__PURE__*/ React.createElement(Skeleton, {
        variant: "rectangular",
        width: "48%",
        height: 120,
        sx: {
            borderRadius: 1
        }
    }))), /*#__PURE__*/ React.createElement(Box, null, /*#__PURE__*/ React.createElement(Skeleton, {
        variant: "text",
        width: "20%",
        height: 28,
        sx: {
            mb: 2
        }
    }), ['skeleton-1', 'skeleton-2', 'skeleton-3', 'skeleton-4', 'skeleton-5'].map(function (id) {
        return /*#__PURE__*/ React.createElement(Box, {
            key: id,
            sx: {
                display: 'flex',
                gap: 2,
                mb: 1
            }
        }, /*#__PURE__*/ React.createElement(Skeleton, {
            variant: "rectangular",
            width: "15%",
            height: 24
        }), /*#__PURE__*/ React.createElement(Skeleton, {
            variant: "rectangular",
            width: "25%",
            height: 24
        }), /*#__PURE__*/ React.createElement(Skeleton, {
            variant: "rectangular",
            width: "20%",
            height: 24
        }), /*#__PURE__*/ React.createElement(Skeleton, {
            variant: "rectangular",
            width: "15%",
            height: 24
        }), /*#__PURE__*/ React.createElement(Skeleton, {
            variant: "rectangular",
            width: "10%",
            height: 24
        }));
    }))));
};
var Product = function Product() {
    var _useParams = useParams(), product = _useParams.product;
    var location = useLocation();
    var _useState = useState(null), _useState2 = _slicedToArray(_useState, 2), remoteComponent = _useState2[0], setRemoteComponent = _useState2[1];
    var _useState3 = useState([]), _useState4 = _slicedToArray(_useState3, 2), applicationsList = _useState4[0], setApplicationsList = _useState4[1];
    var _useState5 = useState(undefined), _useState6 = _slicedToArray(_useState5, 2), previousLoadKey = _useState6[0], setPreviousLoadKey = _useState6[1];
    var getApplications = useApplicationsList();
    useEffect(function () {
        var loadApplications = /*#__PURE__*/ function () {
            var _ref3 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee3() {
                var apps, _t3;
                return _regenerator().w(function (_context3) {
                    while (1)
                        switch (_context3.p = _context3.n) {
                            case 0:
                                _context3.p = 0;
                                _context3.n = 1;
                                return getApplications();
                            case 1:
                                apps = _context3.v;
                                setApplicationsList(apps);
                                _context3.n = 3;
                                break;
                            case 2:
                                _context3.p = 2;
                                _t3 = _context3.v;
                                console.error('Error loading applications:', _t3);
                            case 3:
                                return _context3.a(2);
                        }
                }, _callee3, null, [[0, 2]]);
            }));
            return function loadApplications() {
                return _ref3.apply(this, arguments);
            };
        }();
        loadApplications();
    }, [getApplications]);
    useEffect(function () {
        var cancelled = false;
        setRemoteComponent(null);
        // Wait for applications list to be loaded
        if (!applicationsList || applicationsList.length === 0) {
            return;
        }
        var getBaseUrlForProduct = function getBaseUrlForProduct(routeProduct) {
            if (!routeProduct)
                return null;
            try {
                var _match$details;
                if (!Array.isArray(applicationsList)) {
                    console.error('Unexpected applications list:', applicationsList);
                    return null;
                }
                var products = applicationsList;
                // Match primarily on details.productname, fallback to top-level name
                // Use case-insensitive matching for flexibility
                var routeProductLower = routeProduct.toLowerCase();
                var match = products.find(function (p) {
                    var _p$details, _p$name;
                    return (p === null || p === void 0 || (_p$details = p.details) === null || _p$details === void 0 || (_p$details = _p$details.productName) === null || _p$details === void 0 ? void 0 : _p$details.toLowerCase()) === routeProductLower || (p === null || p === void 0 || (_p$name = p.name) === null || _p$name === void 0 ? void 0 : _p$name.toLowerCase()) === routeProductLower;
                });
                if (!match) {
                    console.error("No application found: \"".concat(routeProduct, "\""));
                    return null;
                }
                var baseUrl = match === null || match === void 0 || (_match$details = match.details) === null || _match$details === void 0 ? void 0 : _match$details.productUrl;
                return baseUrl !== null && baseUrl !== void 0 ? baseUrl : null;
            }
            catch (e) {
                console.error('Failed to get base URL:', e);
                return null;
            }
        };
        var load = /*#__PURE__*/ function () {
            var _ref4 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee4() {
                var baseUrl, entryUrl, scope, currentLoadKey, shouldForceReload;
                return _regenerator().w(function (_context4) {
                    while (1)
                        switch (_context4.n) {
                            case 0:
                                baseUrl = getBaseUrlForProduct(product);
                                if (!(cancelled || !product || !baseUrl)) {
                                    _context4.n = 1;
                                    break;
                                }
                                if (!baseUrl)
                                    console.error("No baseUrl found for product \"".concat(product, "\""));
                                return _context4.a(2);
                            case 1:
                                entryUrl = "".concat(baseUrl, "/remoteEntry.js");
                                scope = "".concat(product, "App"); // Create a unique key combining product name and URL
                                // This ensures reload when either the product OR the URL changes
                                currentLoadKey = "".concat(product, "|").concat(entryUrl); // Always force reload when navigating (except initial load for tests)
                                // This ensures fresh remoteEntry.js call on every application click
                                shouldForceReload = previousLoadKey !== undefined;
                                _context4.n = 2;
                                return loadComponentAsync(scope, product, entryUrl, function (lazyComp) {
                                    if (cancelled)
                                        return;
                                    setRemoteComponent(lazyComp);
                                }, shouldForceReload);
                            case 2:
                                // Update previous load key after loading
                                setPreviousLoadKey(currentLoadKey);
                            case 3:
                                return _context4.a(2);
                        }
                }, _callee4);
            }));
            return function load() {
                return _ref4.apply(this, arguments);
            };
        }();
        load();
        return function () {
            cancelled = true;
        };
    }, [product, applicationsList, location.pathname]);
    return remoteComponent ? /*#__PURE__*/ React.createElement(RemoteAppWrapper, {
        appName: product,
        enableStyleScoping: true
    }, /*#__PURE__*/ React.createElement(Suspense, {
        fallback: /*#__PURE__*/ React.createElement(SkeletonLoader, null)
    }, /*#__PURE__*/ React.createElement(remoteComponent, {
        currentPath: location.pathname,
        search: location.search,
        hash: location.hash
    }))) : /*#__PURE__*/ React.createElement(SkeletonLoader, null);
};
export default authenticatedRoute(Product);
